import { useDispatch } from "react-redux";

import { get_address } from "../api";
import { set_user_address } from "../actions";
import { addressesSelector } from "../selectors";
import useReduxSwr from "../../global/hooks/useReduxSwr";
import { Address } from "../../../types/server";

export default useFavoriteLocations;

function useFavoriteLocations() {
  let dispatch = useDispatch();
  let { data, isValidating, error, revalidate } = useReduxSwr<Address[]>({
    fetcher: () => get_address(),
    selector: addressesSelector,
    onFinished: (data) => dispatch(set_user_address(data)),
  });

  return {
    data,
    error: error,
    isValidating,
    revalidate,
  };
}
